/**
 * How a policy-rate quote is written on the macro strip. Shared so it is
 * testable from the server's runner; the client only renders the strings.
 */
import { formatDateId } from './format.js';
/** `5.75` → `5,75%` — Indonesian decimal comma, two places, like the rest of the strip. */
export function policyRateValue(quote) {
    return `${quote.value.toFixed(2).replace('.', ',')}%`;
}
/**
 * One line under the number.
 *
 *   unchanged at the last decision → `RDG 19 Agu 2026 · ditahan di 5,75%`
 *   raised                          → `RDG 18 Jun 2026 · naik dari 5,50%`
 *   cut                             → `RDG 20 Mei 2026 · turun dari 5,75%`
 *   no previous known               → `RDG 19 Agu 2026 · Live`
 *   BIS fallback (lags weeks)       → `Data BIS per 22 Jul 2026 · Live`
 *
 * A policy rate has no meaningful 30-day change, so this deliberately does not
 * reuse the `▲ x% / 30 hari` note the traded quotes carry.
 */
export function policyRateNote(quote) {
    if (quote.provider === 'bis') {
        return `Data BIS per ${formatDateId(quote.decidedOn)} · Live`;
    }
    const rdg = `RDG ${formatDateId(quote.decidedOn)}`;
    if (quote.previousValue == null)
        return `${rdg} · Live`;
    const prev = `${quote.previousValue.toFixed(2).replace('.', ',')}%`;
    if (quote.previousValue === quote.value)
        return `${rdg} · ditahan di ${policyRateValue(quote)}`;
    return `${rdg} · ${quote.value > quote.previousValue ? 'naik' : 'turun'} dari ${prev}`;
}
//# sourceMappingURL=policyRate.js.map